import $ from "jquery";

const miListingFilter = () => {
  const init = () => {
    sorterHandler();
    dropdownHandler(); // init the div-based dropdown wiring
  };

  const sorterHandler = () => {
    const $select = $('#mi-listing-sorter');
    if (!$select.length) return;

    $select.on('change', function(){
        const val = $(this).val();
        const queryId = $(this).data('queryId') || 'mi-listing-query';
        const newUrl = updateQueryStringParameter(window.location.href, 'sort_by', val);

        const ev = new CustomEvent('miListingSorterChanged', { detail: { queryId: queryId, sort: val, url: newUrl } });
        window.dispatchEvent(ev);

        // Optional global hook (progressive enhancement)
    if (window.miListingSorterApply && typeof window.miListingSorterApply === 'function') {
      try { window.miListingSorterApply(queryId, val, newUrl); return; } catch (err) { /* ignore errors from global hook */ }
    }

        // Fallback: reload page so server-side code can apply sorting
        window.location.href = newUrl;
    });
  };

  const dropdownHandler = () => {
    // Wire up any div-based custom dropdowns (progressive enhancement)
    const $containers = $('.mi-listing-dropdown');
    if (!$containers.length) return;

    $containers.each(function () {
      const $container = $(this);
      const $toggle = $container.find('.mi-listing-dropdown-toggle');
      const $menu = $container.find('.mi-listing-dropdown-menu');
      const $items = $menu.find('.mi-listing-dropdown-item');
      const $hiddenSelect = $('#mi-listing-sorter'); // kept for compatibility

      const open = () => {
        $container.attr('aria-expanded', 'true');
        $toggle.attr('aria-expanded', 'true');
        $menu.addClass('show');
      };

      const close = () => {
        $container.attr('aria-expanded', 'false');
        $toggle.attr('aria-expanded', 'false');
        $menu.removeClass('show');
      };

      $toggle.on('click', function (e) {
        e.preventDefault();
        if ($container.attr('aria-expanded') === 'true') close(); else open();
      });

      // handle item click
      $items.each(function () {
        const $item = $(this);
        $item.attr('tabindex', 0);
        $item.on('click', function () {
          const value = $item.attr('data-value') || '';
          const label = $item.text() || '';
          $container.find('.mi-listing-dropdown-selected').text(label);
          $items.removeClass('selected').attr('aria-selected', 'false');
          $item.addClass('selected').attr('aria-selected', 'true');

          // Sync hidden select and trigger change so existing logic runs
          if ($hiddenSelect.length) {
            try {
              $hiddenSelect.val(value).trigger('change');
            } catch (err) {
              /* ignore errors when syncing hidden select */
            }
          }

          close();
        });

        // keyboard support on items
        $item.on('keydown', function (e) {
          const idx = $items.index($item);
          const key = e.which || e.keyCode;
          if (key === 13 || key === 32) { // Enter or Space
            e.preventDefault(); $item.trigger('click');
          } else if (key === 40) { // Down
            e.preventDefault(); $items.eq((idx + 1) % $items.length).focus();
          } else if (key === 38) { // Up
            e.preventDefault(); $items.eq((idx - 1 + $items.length) % $items.length).focus();
          } else if (key === 27) { // Esc
            e.preventDefault(); close(); $toggle.focus();
          }
        });
      });

      // keyboard support on toggle
      $toggle.on('keydown', function (e) {
        const key = e.which || e.keyCode;
        if (key === 40) { // Down
          e.preventDefault(); open(); $items.first().focus();
        }
        if (key === 13 || key === 32) { // Enter or Space
          e.preventDefault(); $toggle.trigger('click');
        }
      });

      // close when clicking outside
      $(document).on('click.miListingDropdown', function (e) {
        if (!$.contains($container[0], e.target) && $container[0] !== e.target) {
          close();
        }
      });
    });
  };

  const updateQueryStringParameter = (uri, key, value) => {
    const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    const separator = uri.indexOf('?') !== -1 ? '&' : '?';
    if (value === '' || value === null) {
        uri = uri.replace(re, '$1');
        uri = uri.replace(/[?&]$/, '');
        return uri;
    }
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + encodeURIComponent(value) + '$2');
    } else {
        return uri + separator + key + '=' + encodeURIComponent(value);
    }
  };

  init();
};

try {
  miListingFilter();
} catch (e) {
  console.error("MI Listing Filter : ", e);
}